var map = {
	"./brush.svg": [
		"9a37",
		"icon-brush-svg"
	],
	"./channel.svg": [
		"068b",
		"icon-channel-svg"
	],
	"./chatfood-icon.svg": [
		"637f",
		"icon-chatfood-icon-svg"
	],
	"./chatfood-logo-new.svg": [
		"b5d0",
		"icon-chatfood-logo-new-svg"
	],
	"./chatfood-logo.svg": [
		"e93d",
		"icon-chatfood-logo-svg"
	],
	"./check-circle.svg": [
		"0eb2",
		"icon-check-circle-svg"
	],
	"./checkmark.svg": [
		"beb7",
		"icon-checkmark-svg"
	],
	"./copy.svg": [
		"8ca4",
		"icon-copy-svg"
	],
	"./cross-widget.svg": [
		"fd92",
		"icon-cross-widget-svg"
	],
	"./delivery-areas-sidebar.svg": [
		"c329",
		"icon-delivery-areas-sidebar-svg"
	],
	"./delivery-areas.svg": [
		"ed6b",
		"icon-delivery-areas-svg"
	],
	"./diamond.svg": [
		"a8b4",
		"icon-diamond-svg"
	],
	"./dine-in.svg": [
		"f38e",
		"icon-dine-in-svg"
	],
	"./discount-gray.svg": [
		"2faa",
		"icon-discount-gray-svg"
	],
	"./discount.svg": [
		"7035",
		"icon-discount-svg"
	],
	"./eye-slash.svg": [
		"fd50",
		"icon-eye-slash-svg"
	],
	"./eye.svg": [
		"ee34",
		"icon-eye-svg"
	],
	"./facebook.svg": [
		"79ec",
		"icon-facebook-svg"
	],
	"./google.svg": [
		"ef4f",
		"icon-google-svg"
	],
	"./info.svg": [
		"31ed",
		"icon-info-svg"
	],
	"./instagram.svg": [
		"bd5e",
		"icon-instagram-svg"
	],
	"./link.svg": [
		"8063",
		"icon-link-svg"
	],
	"./loading.svg": [
		"2fd8",
		"icon-loading-svg"
	],
	"./map-marker.svg": [
		"07fae",
		"icon-map-marker-svg"
	],
	"./messenger.svg": [
		"0f7d",
		"icon-messenger-svg"
	],
	"./motorcycle.svg": [
		"9c9d",
		"icon-motorcycle-svg"
	],
	"./plus-circle.svg": [
		"6ed4",
		"icon-plus-circle-svg"
	],
	"./shop-circle.svg": [
		"84f9",
		"icon-shop-circle-svg"
	],
	"./shop.svg": [
		"a5c5",
		"icon-shop-svg"
	],
	"./shopping-basket.svg": [
		"9dbc",
		"icon-shopping-basket-svg"
	],
	"./tag.svg": [
		"36d7",
		"icon-tag-svg"
	],
	"./times-circle.svg": [
		"637b",
		"icon-times-circle-svg"
	],
	"./trash.svg": [
		"37a1",
		"icon-trash-svg"
	],
	"./vip.svg": [
		"06c2",
		"icon-vip-svg"
	],
	"./whatsapp.svg": [
		"499a",
		"icon-whatsapp-svg"
	],
	"./zoom-in.svg": [
		"b45a",
		"icon-zoom-in-svg"
	],
	"./zoom-out.svg": [
		"8262",
		"icon-zoom-out-svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ec9f";
module.exports = webpackAsyncContext;